import Vue from 'vue'
import {
    db
} from '../resources/firebase'
import firebase from 'firebase/app'
import 'firebase/firestore'

export const groupsMixin = {
    methods: {
        removeGroupFromAllUsers(activeGroupMembers, groupToDelete) {
            //Get all group members IDs
            let groupMembers = activeGroupMembers.map(item => item.userID || item.objectID)

            //Remove the active group from all group members, using their IDs
            let groupsRemoved = new Promise((resolve, reject) => {
                groupMembers.forEach((memberID, index) => {
                    db.collection("users").doc(memberID).update({
                            "groups": firebase.firestore.FieldValue.arrayRemove(groupToDelete.groupID),
                        })
                        .then(() => {
                            if (index === groupMembers.length - 1) {
                                resolve(true)
                            }
                        })
                        .catch((error) => {
                            // console.log(error)
                            reject(new Error(error))
                        })
                })
            })

            //After removal, promise executes
            groupsRemoved.then((data) => {
                    //Delete group doc from groups collection
                    db.collection("test_groups").doc(groupToDelete.groupID)
                        .delete()
                        .then(() => {
                            //Remove group from state
                            this.$store.commit('deleteGroup', groupToDelete.groupID)

                            //Show toast
                            this.$toasted.show(`Group deleted`, {
                                theme: 'bubble',
                                position: 'bottom-center',
                                duration: 2500
                            })

                            // TO DO
                            // Let all users know group was deleted
                            // Cloud functions maybe
                        })
                        .catch(() => {
                            // console.log(error)
                            throw new Error(error)
                        })
                })
                .catch((error) => {
                    // console.log(error)
                    throw new Error(error)
                })
        },
        removeGroupFromAuthUser(groupToDelete) {
            const authUser = this.$store.state.user.authUser.uid
            db.collection("users").doc(authUser).update({
                    "groups": firebase.firestore.FieldValue.arrayRemove(groupToDelete.groupID),
                })
                .then(() => {
                    //Remove user from group members
                    db.collection("test_groups").doc(groupToDelete.groupID)
                        .update({
                            "members": firebase.firestore.FieldValue.arrayRemove(authUser)
                        })
                        .then(() => {
                            //Remove group from state
                            this.$store.commit('deleteGroup', groupToDelete.groupID)

                            //Show toast
                            this.$toasted.show(`Group left`, {
                                theme: 'bubble',
                                position: 'bottom-center',
                                duration: 2500
                            })
                        })
                        .catch(() => {
                            // console.log(error)
                            throw new Error(error)
                        })
                })
                .catch((error) => {
                    // console.log(error)
                    throw new Error(error)
                })
        },
        showGroupsModal() {
            const html = document.querySelector('html')
            const app = document.querySelector('#app')
            app.classList.add('blur-app')
            html.style.overflowY = 'hidden'

            //Set payload
            let payload = {
                show: true,
                from: 'groups-list'
            }
            //Set state
            this.$store.commit('updateGroupsModal', payload)
        }
    }
}



// WEBPACK FOOTER //
// ./src/mixins/groupsMixin.js